import { Self } from '../../../shared/self';
/** Базовые данные о профиле пользователя для отображения в HeaderWidget */
export var useHeaderProfile = Self.derive(function (_a, locale) {
    var _b, _c, _d;
    var self = _a.self;
    if (!self) {
        return;
    }
    var name = (_b = self.profileInfo.names) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.lang === locale; });
    return {
        firstName: name === null || name === void 0 ? void 0 : name.firstName,
        lastName: name === null || name === void 0 ? void 0 : name.lastName,
        avatarUrl: (_d = (_c = self.profileInfo) === null || _c === void 0 ? void 0 : _c.avatar) === null || _d === void 0 ? void 0 : _d.mainLink,
        type: self.profileInfo.type,
    };
});
